import React from "react";
import styles from './ApproveButton.module.scss';
import {IProduct} from 'data/interfaces/products';
import {Button} from "@material-ui/core";

export interface IApproveButton {
  product: IProduct;
  approve: (product_id: number) => void;
}

const ApproveButton = (props: IApproveButton) => <Button
  variant="contained"
  className={`${styles.actionButtons} ${styles.approveButton}`}
  onClick={() => {
    return props.approve(props.product.id);
  }}
>אשר</Button>;

ApproveButton.defaultProps = {
  product: {},
};

export default ApproveButton;
